import Link from './Link';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, Link.extend`
  padding: 0 ${theme.unit * 2}px;
  text-decoration: none;
  line-height: ${theme.unit * 6}px;
`);



// WEBPACK FOOTER //
// ./src/components/links/LinkButtonLink.js